import React from 'react';
import * as routes from '../routes';

/* Account menu */
export const userProfile = {
  label: 'Profilo utente',
  route: routes.userProfileRoute,
};

export const changeAccount = {
  label: 'Cambia ruolo',
  route: routes.changeAccountRoute,
};

export const manageNotification = {
  label: 'Notifiche',
  route: routes.manageNotificationRoute,
  component: React.lazy(() =>
    import('../components/Page/components/Header/components/NotificationBadge')
  ),
};

export const support = {
  label: 'Supporto',
  route: routes.supportRoute,
};

export const userGuide = {
  label: 'Manuale utente',
  route: routes.userGuideRoute,
};

export const logout = {
  label: 'Esci',
  route: routes.logoutRoute,
};
